var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconThumbsDown40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2279_8911)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9727 8.16837H11.4896C10.2767 8.16837 9.3029 9.27904 8.50979 10.4053C5.522 14.648 4.88036 20.9895 4.88036 22.571C4.88036 24.1524 6.08407 24.7351 8.03331 24.7351H16.7197C15.7568 26.7982 14.4107 29.2593 14.4107 31.0053C14.4107 32.8956 15.133 34.2529 16.7489 34.2529C18.3647 34.2529 18.7793 32.92 19.3578 31.6212C20.4234 29.2284 22.6721 23.8173 25.9727 23.8173L25.9727 8.16837Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3125 7.37796H25.8272V25.5581H35.3125V7.37796Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6929 12.2679L29.6734 12.2491C29.1708 11.7667 29.1546 10.9683 29.637 10.4657C29.6489 10.4534 29.661 10.4413 29.6734 10.4294L29.6929 10.4107C30.2115 9.91272 31.0307 9.91272 31.5493 10.4107L31.5688 10.4294C32.0714 10.9118 32.0876 11.7103 31.6052 12.2128C31.5933 12.2252 31.5812 12.2373 31.5688 12.2491L31.5493 12.2679C31.0307 12.7658 30.2115 12.7658 29.6929 12.2679Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2279_8911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconThumbsDown40);
export default __webpack_public_path__ + "static/media/pictogramBeaconThumbsDown40.4364c08754e50d4703dc039c55eac4b7.svg";
export { ForwardRef as ReactComponent };